
import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavItem } from './NavItem';
import { NavItemType } from './types';

interface NavigationListProps {
  navItems: NavItemType[];
  isActive: (path: string) => boolean;
  onItemClick?: () => void;
  onSignOut: () => void;
}

export function NavigationList({ navItems, isActive, onItemClick, onSignOut }: NavigationListProps) {
  return (
    <div className="space-y-4">
      <div className="px-3 py-2">
        <h2 className="mb-2 px-2 text-lg font-semibold">Content Management</h2>
        <div className="space-y-1">
          {navItems.map((item) => (
            <NavItem
              key={item.to}
              to={item.to}
              icon={item.icon}
              label={item.label}
              active={isActive(item.to)}
              onClick={onItemClick}
            />
          ))}
        </div>
      </div>
      <Separator />
      <div className="px-3 py-2">
        <Button
          variant="ghost"
          className="w-full justify-start"
          onClick={onSignOut}
        >
          <LogOut size={18} />
          <span className="ml-3">Sign out</span>
        </Button>
      </div>
    </div>
  );
}
